import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import IncidentCardNode from '@/components/wysiwyg-components/nodes/incident/card/IncidentCardNode.vue'

export default Node.create({
  name: 'incident-card',
  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      incidentId: {
        default: null,
        parseHTML: element => element.getAttribute('incident-id'),
        renderHTML: attributes => ({ 'incident-id': attributes.incidentId }),
      },
    }
  },

  parseHTML() {
    return [{ tag: 'incident-card' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['incident-card', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return VueNodeViewRenderer(IncidentCardNode)
  },
})
